import { render, staticRenderFns } from "./assist-visit-confirm-distribution.vue?vue&type=template&id=842be91a&scoped=true"
import script from "./assist-visit-confirm-distribution.vue?vue&type=script&lang=ts"
export * from "./assist-visit-confirm-distribution.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "842be91a",
  null
  
)

export default component.exports